import { useQuery } from '@tanstack/react-query'
import { Outlet } from '@tanstack/react-router'

import { getUserQuery } from '@/lib/queries/business/v2/user/queries'
import { cn } from '@/lib/utils'

import { DOM_ID } from './constants'
import { RegisterApplicantDialog } from './ui/dialogs/register-applicant-dialog'
import { NavBar } from './ui/nav-bar/nav-bar'
import { SideNavigationBar } from './ui/side-navigation-bar/side-navigation-bar'
import { SubscribeBanner } from './ui/subscribe-banner'

export const AppLayout = () => {
  const { data: dataUser } = useQuery(getUserQuery)

  return (
    <>
      <div className="relative h-full">
        {/* Top */}
        <div
          className={cn(
            'fixed left-0 right-0 top-0 z-20 bg-white',
            dataUser?.hasSubscription ? 'h-nav-bar' : 'h-nav-bar-top-banner'
          )}
        >
          {!dataUser?.hasSubscription && <SubscribeBanner />}
          <NavBar />
        </div>

        <div className={`flex`}>
          {/* Left */}
          <div>
            <SideNavigationBar />
          </div>

          {/* Right */}
          <div
            className={cn(
              `h-screen flex-1 overflow-hidden`,
              dataUser?.hasSubscription ? 'pt-nav-bar' : 'pt-nav-bar-top-banner'
            )}
          >
            <div id={DOM_ID.appRouteOutletWrapper} className="h-full w-full overflow-auto">
              <Outlet />
            </div>
          </div>
        </div>
      </div>

      {/* Dialog: Register Case */}
      <RegisterApplicantDialog />
    </>
  )
}
